// extracted by mini-css-extract-plugin
export const testimonials = "testimonials-module--testimonials--gi6EM";
export const grid = "testimonials-module--grid--2g4cB";
export const card = "testimonials-module--card--3fIai";
export const image = "testimonials-module--image--3elsi";
export const content = "testimonials-module--content--2gxI-";
export const byline = "testimonials-module--byline--2gsrD";